module.exports = __webpack_public_path__ + "static/img/img-process.0891538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-process.png
// module id = uRpV
// module chunks = 1